import { useSwitchState } from 'hooks/useSwitchState'

import { ModalCloseCallback, TPostForm } from '../types'

type TModalHandlersProps = Pick<
  TPostForm,
  'feed' | 'onCloseModal' | 'modalTitleText'
> & {
  isPollStep: boolean
  isChangedForm: boolean
  closeCb?: ModalCloseCallback
  onModalBack: () => void
  togglePollStep: () => void
}

const useModalHandlers = ({
  feed,
  isPollStep,
  modalTitleText,
  togglePollStep,
  isChangedForm,
  closeCb,
  onCloseModal,
  onModalBack,
}: TModalHandlersProps) => {
  const [
    isOpenUnsavedChangesModal,
    openUnsavedChangesModal,
    closeUnsavedChangesModal,
  ] = useSwitchState()

  const handleCloseModal = () => {
    closeUnsavedChangesModal()
    closeCb?.current?.()
    onCloseModal?.()
  }

  const handleCloseOrConfirm = () => {
    if (isChangedForm) {
      openUnsavedChangesModal()
    } else handleCloseModal()
  }

  const isEditModal = !!feed
  const isEditPoll = !!feed?.poll

  const handleBackPollStep = () => {
    if (isChangedForm) {
      onModalBack()
    } else togglePollStep()
  }

  const handleBackModal =
    isPollStep && !isEditPoll ? handleBackPollStep : undefined

  const pollTitle = isEditPoll ? 'Poll editing' : 'Poll'
  const postTitle = feed ? 'Post editing' : 'New post'

  const modalTitle =
    modalTitleText || (isEditPoll || isPollStep ? pollTitle : postTitle)

  const createPostButtonText = isPollStep ? 'Post poll' : 'Post'
  const buttonText = isEditModal ? 'Save' : createPostButtonText

  return {
    modalTitle,
    buttonText,
    isOpenUnsavedChangesModal,
    handleBackModal,
    handleCloseModal,
    closeUnsavedChangesModal,
    handleCloseOrConfirm,
  }
}

export default useModalHandlers
